<script setup lang="ts">
/**
 * Text with `$…$` inline math rendered by KaTeX, the way the student player draws it. The markup is
 * escaped text plus KaTeX's own output (`renderMathText`), so `v-html` is safe here.
 */
import 'katex/dist/katex.min.css'

import { renderMathText } from '../../../../../model/assignments/math-exercise-preview.hook'

defineOptions({
  name: 'MathText',
})

const props = withDefaults(defineProps<{
  value: string
  tag?: 'p' | 'span'
}>(), {
  tag: 'span',
})

const refHtml = computed<string>(() => renderMathText(props.value))
</script>

<template>
  <p
    v-if="tag === 'p'"
    class="math-text"
    v-html="refHtml"
  />
  <span
    v-else
    class="math-text"
    v-html="refHtml"
  />
</template>

<style scoped lang="scss" src="./MathText.scss" />
